import { render, staticRenderFns } from "./WellcomeDialog.vue?vue&type=template&id=2ca22936&scoped=true"
import script from "./WellcomeDialog.vue?vue&type=script&lang=js"
export * from "./WellcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./WellcomeDialog.vue?vue&type=style&index=0&id=2ca22936&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca22936",
  null
  
)

export default component.exports